module.exports = __webpack_public_path__ + "static/media/Mini Project-SY EXTC 22-23.68c4e991.pdf";